import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import { Link } from 'react-router-dom';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'https://yymanhua.com' },
        { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://yymanhua.com/about' },
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'yy漫画网提供什么样的漫画资源？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'yy漫画网主要提供韩漫免费漫画资源，涵盖恋爱浪漫、奇幻冒险、动作热血、悬疑推理、搞笑日常、都市生活等多种分类，所有漫画均支持下拉式在线阅读。',
          },
        },
        {
          '@type': 'Question',
          name: '如何在yy漫画网阅读漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '访问yy漫画网后，您可以在首页浏览热门推荐漫画，或通过分类导航找到感兴趣的漫画类型。点击任意漫画即可进入详情页查看章节列表，选择章节即可开始下拉式阅读。',
          },
        },
        {
          '@type': 'Question',
          name: 'yy漫画网的漫画是否需要付费？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'yy漫画网提供韩漫免费漫画在线阅读服务，所有漫画资源均可免费阅读，无需注册或付费即可畅享全部内容。',
          },
        },
        {
          '@type': 'Question',
          name: 'yy漫画网支持哪些设备阅读？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'yy漫画网支持电脑、平板和手机等多种设备访问，采用下拉式阅读模式，在任何设备上都能获得流畅的漫画阅读体验。',
          },
        },
      ],
    },
    {
      '@type': 'AboutPage',
      name: '关于yy漫画网',
      description: 'yy漫画网是专业的韩漫免费漫画在线阅读平台，提供丰富的韩国漫画资源和优质的下拉式阅读体验。',
      url: 'https://yymanhua.com/about',
      isPartOf: { '@type': 'WebSite', name: 'yy漫画网', url: 'https://yymanhua.com' },
    },
  ],
};

export default function About() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="关于我们 - 品牌介绍与联系方式 - yy漫画网"
        description="yy漫画网品牌介绍：作为专业的漫画韩漫网址，提供韩漫免费漫画和在线阅读下拉式韩国漫画服务。了解我们的品牌故事、用户口碑与联系方式。"
        keywords="yy漫画网,关于我们,韩漫免费漫画,在线阅读下拉式韩国漫画,漫画韩漫网址,品牌介绍"
        canonicalUrl="/about"
        schemaJson={aboutSchema}
      />
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100/70">
          <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs" />
              <span className="text-foreground-900 font-medium">关于我们</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl text-foreground-900 mb-3">关于 yy漫画网</h1>
            <p className="text-sm text-foreground-500 max-w-2xl">
              yy漫画网作为漫画韩漫网址，致力于为广大韩漫爱好者提供优质的韩漫免费漫画在线阅读服务。
            </p>
          </div>
        </div>

        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-20">
          <section className="mb-16">
            <h2 className="font-heading text-2xl text-foreground-900 mb-6">品牌故事</h2>
            <div className="bg-background-100/70 rounded-xl p-8 md:p-10">
              <div className="max-w-3xl">
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  yy漫画网成立于2023年，是由一群热爱韩国漫画的年轻人共同创立的在线阅读平台。我们深知韩漫爱好者在寻找高质量、更新及时的漫画资源时的困扰——资源分散、阅读体验差、翻译质量参差不齐等问题一直困扰着广大读者。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  正是基于这样的洞察，我们决心打造一个真正属于韩漫爱好者的阅读家园。yy漫画网汇聚了海量的韩漫免费漫画资源，涵盖<strong>恋爱浪漫、奇幻冒险、动作热血、悬疑推理、搞笑日常、都市生活</strong>等多个分类，并与时俱进地引入了下拉式阅读模式，让读者可以像浏览网页一样流畅地阅读每一话漫画。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  经过不断的发展与优化，yy漫画网已经成为国内知名的<strong>漫画韩漫网址</strong>之一，日均活跃用户超过百万。我们坚持免费开放的原则，让每一位韩漫爱好者都能随时随地享受<strong>在线阅读下拉式韩国漫画</strong>的乐趣，不受时间和地点的限制。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  未来，yy漫画网将继续深耕韩漫领域，不断扩充资源库，优化阅读体验，为读者提供更加丰富、便捷的漫画阅读服务。我们相信，好的漫画值得被更多人看到。
                </p>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading text-2xl text-foreground-900 mb-6">核心优势</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  icon: 'ri-database-2-line',
                  title: '海量资源库',
                  desc: '持续收录最新最热门的韩漫免费漫画，涵盖六大主流分类，满足不同读者的口味偏好，每周稳定更新数十部新作。',
                },
                {
                  icon: 'ri-flashlight-line',
                  title: '极速加载',
                  desc: '采用先进的图片加载技术，实现漫画页面的秒开体验。下拉式阅读模式下图片无缝衔接，让你专注于故事本身。',
                },
                {
                  icon: 'ri-translate',
                  title: '精良翻译',
                  desc: '专业翻译团队精心打磨每一句台词，保留原作韵味的同时确保中文表达自然流畅，让韩漫阅读毫无障碍。',
                },
                {
                  icon: 'ri-device-line',
                  title: '多端适配',
                  desc: '完美适配电脑、平板、手机等全设备访问，无论你在哪里都能获得一致的下拉式韩国漫画阅读体验。',
                },
                {
                  icon: 'ri-shield-check-line',
                  title: '安全可靠',
                  desc: '严格的内容审核机制与稳定的服务器保障，为用户提供安全、稳定的在线阅读环境，杜绝恶意广告与弹窗。',
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: '贴心服务',
                  desc: '7×24小时在线客服支持，及时响应用户反馈。持续优化平台功能，用心倾听每一位读者的声音。',
                },
              ].map((item, i) => (
                <div key={i} className="bg-background-100/70 rounded-xl p-6">
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 mb-4">
                    <i className={`${item.icon} text-xl text-primary-500`} />
                  </div>
                  <h3 className="font-medium text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading text-2xl text-foreground-900 mb-6">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  name: '小漫迷',
                  role: '韩漫爱好者',
                  comment: 'yy漫画网是我天天刷的漫画网站，更新真的很快！下拉式阅读特别方便，画质也很清晰，推荐了好多朋友来看了。',
                  rating: 5,
                },
                {
                  name: '追漫达人',
                  role: '资深读者',
                  comment: '用过的韩漫网站里体验最好的一个，广告少，速度快，分类也很清晰。恋爱类的漫画特别全，每天都在追更新。',
                  rating: 5,
                },
                {
                  name: '漫画控',
                  role: '漫画博主',
                  comment: '作为漫画博主，我经常需要找各种韩漫资源。yy漫画网的资源库真的非常丰富，从热门大作到小众佳作都能找到。',
                  rating: 5,
                },
              ].map((review, i) => (
                <div key={i} className="bg-background-100/70 rounded-xl p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, j) => (
                      <i key={j} className="ri-star-fill text-accent-500 text-sm" />
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    &ldquo;{review.comment}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs font-medium text-primary-600">{review.name[0]}</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading text-2xl text-foreground-900 mb-6">常见问题</h2>
            <div className="space-y-3 max-w-3xl">
              {[
                { q: 'yy漫画网提供什么样的漫画资源？', a: 'yy漫画网主要提供韩漫免费漫画资源，涵盖恋爱浪漫、奇幻冒险、动作热血、悬疑推理、搞笑日常、都市生活等多种分类，所有漫画均支持下拉式在线阅读。' },
                { q: '如何在yy漫画网阅读漫画？', a: '访问yy漫画网后，您可以在首页浏览热门推荐漫画，或通过分类导航找到感兴趣的漫画类型。点击任意漫画即可进入详情页查看章节列表，选择章节即可开始下拉式阅读。' },
                { q: 'yy漫画网的漫画是否需要付费？', a: 'yy漫画网提供韩漫免费漫画在线阅读服务，所有漫画资源均可免费阅读，无需注册或付费即可畅享全部内容。' },
                { q: 'yy漫画网支持哪些设备阅读？', a: 'yy漫画网支持电脑、平板和手机等多种设备访问，采用下拉式阅读模式，在任何设备上都能获得流畅的漫画阅读体验。' },
                { q: '漫画更新频率是怎样的？', a: '我们每天都会更新多部漫画的新章节，与韩国连载保持同步。热门漫画通常日更或隔日更新，确保读者能够第一时间追到最新内容。' },
              ].map((faq, i) => (
                <details key={i} className="bg-background-100/70 rounded-lg group">
                  <summary className="flex items-center justify-between p-5 cursor-pointer text-sm font-medium text-foreground-900">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform" />
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>

          <section id="contact">
            <h2 className="font-heading text-2xl text-foreground-900 mb-6">联系我们</h2>
            <div className="bg-background-100/70 rounded-xl p-8 md:p-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div>
                  <h3 className="font-medium text-foreground-900 mb-4">联系方式</h3>
                  <ul className="space-y-4">
                    <li className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                        <i className="ri-mail-line text-primary-500" />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                        <p className="text-sm text-foreground-600">contact@yymanhua.com</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                        <i className="ri-customer-service-line text-primary-500" />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">在线客服</p>
                        <p className="text-sm text-foreground-600">工作日 9:00 - 18:00</p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                        <i className="ri-map-pin-line text-primary-500" />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">办公地址</p>
                        <p className="text-sm text-foreground-600">中国上海市浦东新区张江高科技园区</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-medium text-foreground-900 mb-4">商务合作</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    如果您有商务合作、版权合作、广告投放等需求，欢迎通过以下方式联系我们。我们的商务团队将在1-2个工作日内与您取得联系。
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-center gap-2 text-sm text-foreground-600">
                      <i className="ri-mail-send-line text-primary-500" />
                      <span>商务合作：biz@yymanhua.com</span>
                    </li>
                    <li className="flex items-center gap-2 text-sm text-foreground-600">
                      <i className="ri-copyright-line text-primary-500" />
                      <span>版权事务：copyright@yymanhua.com</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}